/**
 * Inline SVG icons for People Plan.
 *
 * These mirror assets in src/assets/svg/icons but use `currentColor` so they can
 * be recoloured with Tailwind text classes — an <img> tag cannot be.
 */

export const CheckMarkIcon = ({ className = 'w-5 h-5' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-1.43 -1.43 40 40"
    className={className}
    aria-hidden="true"
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.86"
      d="M1.9896428571428573 22.71508928571429 14.048072357142857 35.150357142857146C19.72232155714286 18.850645757142857 24.447935571428573 11.6981715 35.150357142857146 1.9896428571428573"
    />
  </svg>
);

export const RecycleBinIcon = ({ className = 'w-6 h-6' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="-1.43 -1.43 40 40"
    className={className}
    aria-hidden="true"
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.86"
      fill="none"
    >
      <path d="M3.9792857142857145 10.6411671c9.821540357142858 -1.2918087857142857 19.359888214285714 -1.2918087857142857 29.181428571428572 0" />
      <path d="M6.582083442857143 10.328395242857143c-0.09261124285714285 4.957898185714286 -0.22130134285714287 13.337637214285715 1.3149682285714286 20.188481614285713 0.5947440428571429 2.652061285714286 2.8522989428571432 4.549384714285715 5.5436225142857145 4.928743285714286 1.7396641285714285 0.24538928571428573 3.325727828571429 0.3679512857142857 5.129591100000001 0.3679512857142857 1.8039428571428573 0 3.3902453142857145 -0.122562 5.130148200000001 -0.3679512857142857 2.6913235714285717 -0.37935857142857143 4.948851942857143 -2.276682 5.5436225142857145 -4.928743285714286 1.5362695714285715 -6.850764814285714 1.407606 -15.230450785714288 1.3150212857142858 -20.188375500000003 -8.044974985714287 -0.8748857571428573 -15.932078442857144 -0.8749388142857143 -23.97697384285714 -0.00010611428571428573Z" />
      <path d="M11.719951457142859 9.823848342857143c-0.020480057142857146 -0.26801815714285715 -0.030799671428571433 -1.3326627857142856 -0.030799671428571433 -1.6168899C11.689151785714287 3.8034278142857145 14.166151028571429 1.3264285714285715 18.56968165714286 1.3264285714285715s6.880529871428572 2.476999242857143 6.880529871428572 6.880529871428572c0 0.2842271142857143 -0.010319614285714285 1.348871742857143 -0.0308262 1.6168899" />
      <path d="M14.186418857142858 16.989109371428572c-0.1567308 2.775419142857143 -0.0012733714285714287 7.697981271428572 0.4810160571428572 11.251350771428573m7.8038568 0c0.4821567857142857 -3.553475614285715 0.6373754571428571 -8.476011214285716 0.4806181285714286 -11.251430357142858" />
    </g>
  </svg>
);

export default RecycleBinIcon;
